import Button from "../ui/button";


type CardFeatureProps = {
  link: string;
  title: string;
  description?: string;
  withDecor?: boolean;
  decor?: string;
  icon?: string;
}

const CardFeature = ({link, title, description, withDecor = true, decor, icon}: CardFeatureProps) => {
  const featureClassNameContainer = withDecor ? "border border-izygray rounded-lg flex flex-col sm:flex-row" : "grid place-items-center";
  const featureClassNameContent = withDecor ? "sm:px-4 md:px-6 flex flex-col justify-center flex-1" : "grid place-items-center text-center";
  

  return (
    <div className={`w-full max-w-[320px] md:max-w-none lg:max-w-[320px] min-h-[191px]  ${featureClassNameContainer}`}>
      { withDecor ? (
        <div className={`py-2 px-2 sm:py-0 sm:w-1/3 sm:border-r border-izygray grid place-items-center ${decor ?? ''}`}>
          <img className="w-8 sm:w-12 lg:w-fit" src={icon ?? ''} />
        </div>
        ) : <></>
      }
      <div className={`gap-1 py-5 xl:py-0 ${featureClassNameContent}`}>
        <h3 className="m-0 text-shadow text-md sm:text-lg font-bold text-center sm:text-start">{title}</h3>
        <p className="m-0 text-shadow text-sm text-center sm:text-start">{description}</p>
        <Button
          tag="link" to={link}
          disabled={!withDecor}
          width="fit"
          size="small"
          rounded={withDecor ? 'medium' : 'large'}
          theme={withDecor ? 'primary' : 'outline-primary'}
          className="mt-3 mx-auto sm:mx-0 px-7 w-fit" >
          {withDecor ? "Continuer" : "En savoir plus"}
        </Button>
      </div>
    </div>
  )
}

export default CardFeature;